import api from "./api";

export default class PaymentApiNovo {
  static postPaymentSolicitation = async (obj: any, code: any) => {
    const response = await api.post(`/PagamentoNovo`, obj, {
      headers: {
        codigo: code,
      },
    });
    return response.data;
  };

  static getPaymentSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    minValue: any,
    maxValue: any,
    isManual: boolean = false
  ) => {
    const response = await api.get(
      `/PagamentoNovo?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}&dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&valorInicio=${minValue}&valorFim=${maxValue}&Manual=${isManual}`
    );
    return response;
  };

  static getPaymentPerId = async (idPayment: any) => {
    const response = await api.get(`/PagamentoNovo/${idPayment}`);
    return response.data;
  };

  static deletePaymentPerId = async (
    id: number,
    payload: { observacao: string }
  ) => {
    const response = await api.post(`/PagamentoNovo/${id}/cancelar`, payload);
    return response.data;
  };

  static exportPayment = async (
    idStatus: any,
    valorInicio: any,
    valorFim: any,
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string
  ) => {
    const response = await api.get(
      `/PagamentoNovo/exportacao/download?idStatus=${idStatus}&idCliente=${id}&dataInicio=${dataInicio}&dataFim=${dataFim}&valorInicio=${valorInicio}&valorFim=${valorFim}&Search=${search}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static confirmPayment = async (id: number, code: string, valor: number) => {
    const body = {
      codigo: code,
      valor: valor,
    };
    const response = await api.post(`/PagamentoNovo/${id}/Confirmar`, body);
    return response.data;
  };
}
